<template>
  <div class="setting-popup"  v-show='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown.stop.prevent>
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      请选择图片
    </div>
    <div class="setting-popup__content">
      <popup-content ref="popupContent"
        :isPopupShow="boxData.judgeBox"
        @closePopup="close"
      ></popup-content>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../mixins/popup'
import popupContent from './selectFrameImage/content'

export default {
  mixins: [ popup ],
  components: {
    popupContent
  },
  data () {
    return {
      popupType: 'selectFrameImage'
    }
  },
  computed: {

  },
  watch: {
    'boxData.judgeBox' (val) {
      if (val) {
        this.$refs.popupContent.loadData();
      }
    }
  },
  created () {
    this.$bus.on('showSelectFrameImage', () => {
      const vm = this;
      let sprite = vm.SelectSprites_Msg[0];
      this.$bus.emit('FeaturesPop_vue', {
        type: 1,
        name: 'selectFrameImage',
        initialX: vm.TOOL.PfixLeft + sprite.positionLeft - 280,
        initialY: vm.TOOL.PfixTop + sprite.positionTop
      })
    })

    eve.on('helpBtnClicked', ({sprite} = {}) => {
      if (sprite.picData.picSize) { // edit image
        this.$bus.emit('showFrameWidget');
        this.$analysis({category:'editable_frame', action:'click_editable_frame_edit_photos', label:'相框_编辑图片'})
      } else { // add image
        this.$bus.emit('showSelectFrameImage');
        this.$analysis({category:'editable_frame', action:'click_editable_frame_add_photos', label:'相框_添加图片'})
      }
    })
  },
}
</script>

<style lang="scss" scoped>
  .setting-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 258px;
    height: 562px;
    z-index: 35;
    border-radius: 6px 6px 3px 3px;
    background: #fff;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0 0 3px 1px #d8dee9;
    color: #474261;

    &__drag-area {
      line-height: 28px;
      background: #d8dee9;
      text-align: left;
      text-indent: 14px;
      cursor: move;
    }

    &__close {
      position: absolute;
      top: 7px;
      right: 12px;
      height: 14px;
      line-height: 14px;
      width: 14px;
      cursor: pointer;
    }

    &__content {
      padding: 14px 0;
    }

    &__mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#ffffff, 0.7);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/selectFrameImage.vue